import React from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { NextSeo } from "next-seo";
import products from "@/data/products/products";
import ProductHeadingSection from "@/components/product/heading-section";
import ProductNav from "@/components/product/product-nav";
import ProductDetails from "@/components/product/product-details";

const translationNamespaces = ["common", "nav"];

export const getStaticProps = async ({ locale, params: { slug } }) => {
  const product = products.find((product) => product.code === slug);
  return {
    props: {
      product,
      ...(await serverSideTranslations(locale, translationNamespaces)),
    },
  };
};

export const getStaticPaths = async ({ locales }) => {
  const paths = locales
    .map((locale) =>
      products.map((product) => ({
        params: { slug: product.code },
        locale,
      })),
    )
    .flat();
  return {
    paths,
    fallback: false,
  };
};

const Product = ({ product }) => {
  return (
    <>
      <NextSeo
        title={product.name}
        description={product.description}
        canonical={`https://alhayatfoodstuff.com/product/${product.code}`}
        openGraph={{
          title: product.title,
          description: product.description,
          images: [
            {
              url: `https://alhayatfoodstuff.com/img/og/${product.code}.png`,
              width: 1200,
              height: 630,
              alt: product.title,
            },
          ],
        }}
      />
      <ProductHeadingSection product={product} />
      <div className="bg-auto-black/5">
        <div className="container flex w-full flex-col-reverse items-start justify-center gap-8 px-4 py-16 lg:flex-row">
          <ProductNav />
          <ProductDetails product={product} key={product.code} />
        </div>
      </div>
    </>
  );
};

export default Product;
